<template>
  <div>
    <div id="goz_esnetme">
      <h3
        style="
          position: absolute;
          bottom: 10px;
          color: white;
          text-align: center;
          font-size: 22px;
        "
      >
        {{
          started == false ? $t("module.hafiza.des1") : $t("module.hafiza.des2")
        }}
      </h3>

      <div
        class="success-checkmark"
        id="checkmark"
        style="position: absolute; z-index: 9999; display: none"
      >
        <div class="check-icon">
          <span class="icon-line line-tip"></span>
          <span class="icon-line line-long"></span>
          <div class="icon-circle"></div>
          <div class="icon-fix"></div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          background-color: #ddd;
          padding: 5px 0px;
          z-index: 9999;
        "
      >
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          "
        >
          <strong>{{ $t("module.point") }}</strong
          >: {{ point }}
        </div>
        <div
          style="
            display: flex;
            flex: 1;
            align-items: center;
            justify-content: center;
          "
        >
          <strong>{{ $t("module.level") }}</strong
          >: {{ level }}
        </div>
      </div>

      <div>
        <div
          class="squares"
          :style="{
            width: (this.level + 1) * 85 + 'px',
            height: (this.level + 1) * 85 + 'px',
            transform:
              rotate == true
                ? 'rotate(' + (started ? '90deg' : '0deg') + ')'
                : '',
          }"
        >
          <div
            class="square"
            v-for="(i, index) in stack"
            style="width: 80px; height: 80px"
            :class="
              (i.isTrue && i.picked) || (i.isTrue && started == false)
                ? 'picked'
                : ''
            "
            @click="pick(i, index)"
          >
            <i
              class="fas fa-times animate__animated animate__bounceIn"
              v-if="i.picked == true && i.isTrue == false"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import moment from "moment";
import axios from "axios";
export default {
  name: "HafizaKareleri",
  props: ["config", "rotate"],
  data() {
    return {
      level: 1,
      levels: [4, 9, 16],
      stack: [],
      lock: true,
      started: false,
      counter: 3,
      point: 0,
      totalTruePick: 0,
      totalFalsePick: 0,
      totalTrue: 0,
      totalFalse: 0,
      falseStack: 0,
      pause: false,
      left: 0,
      reactions: [],
      lastDate: new Date().getTime(),
      interval: null,
      reactionInterval: null,
    };
  },
  mounted() {
    this.wrapper = {
      width: document.getElementById("goz_esnetme").clientWidth,
      height: document.getElementById("goz_esnetme").clientHeight,
    };
  },
  methods: {
    pick(item, index) {
      if (this.lock || item.picked) return;

      if (item.isTrue) {
        this.point += this.level * 50;
        this.totalTruePick += 1;
        this.reactions.push(new Date().getTime() - this.lastDate);
        this.lastDate = new Date().getTime();
      } else {
        this.totalFalsePick += 1;
        this.falseStack += 1;
        this.lastDate = new Date().getTime();
      }

      this.$set(this.stack, index, { ...this.stack[index], picked: true });
    },
    start() {
      this.left = _.random(0, 1);
      var randoms = [];
      this.stack = [];
      for (
        let index = 0;
        index < Math.floor(this.levels[this.level - 1] / 2);
        index++
      ) {
        randoms.push(_.random(0, this.levels[this.level - 1] - 1));
      }

      for (let index = 0; index < this.levels[this.level - 1]; index++) {
        this.stack.push({
          picked: false,
          isTrue: randoms.some((k) => k == index),
        });
      }

      setTimeout(() => {
        this.started = true;
        this.lock = false;
        this.lastDate = new Date().getTime();

        this.reactionInterval = setTimeout(() => {
          axios.post("module/savePoints", {
            points: [
              {
                point: this.point,
                type: "hafiza",
              },
            ],
            module_id: this.$store.state.modules.find(
              (k) => k.slug == "hafiza-kareleri"
            ).module_id,
          });
        }, 60000);
      }, 3000);
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
    clearInterval(this.reactionInterval);
  },
  created() {
    this.start();
  },
  watch: {
    stack: {
      handler: function () {
        if (this.lock) return;
        if (
          this.stack.filter((k) => k.picked == true && k.isTrue == true)
            .length == this.stack.filter((k) => k.isTrue == true).length
        ) {
          this.totalTrue += 1;
          this.level = Math.min(this.level + 1, this.levels.length);
          this.lock = true;

          $(".squares").removeClass("animate__animated animate__bounceIn");
          $(".squares").addClass("animate__animated animate__bounceOut");
          $("#checkmark").css("display", "block");
          $("#checkmark").removeClass("animate__animated animate__bounceOut");
          $("#checkmark").addClass("animate__animated animate__bounceIn");
          setTimeout(() => {
            this.started = false;
            setTimeout(() => {
              this.start();
              $(".squares").removeClass("animate__animated animate__bounceOut");
              $(".squares").addClass("animate__animated animate__bounceIn");
              setTimeout(() => {
                $(".squares").removeClass(
                  "animate__animated animate__bounceIn"
                );
              }, 550);
              $("#checkmark").css("display", "none");
            }, 2000);
          }, 1000);
        }
      },
      deep: true,
    },
    falseStack: function () {
      if (this.falseStack == this.level + 1) {
        this.falseStack = 0;
        this.totalFalse += 1;
        this.lock = true;
        this.started = false;

        setTimeout(() => {
          $(".squares").removeClass("animate__animated animate__bounceIn");
          $(".squares").addClass("animate__animated animate__bounceOut");
          setTimeout(() => {
            this.level = Math.max(this.level - 1, 1);
          }, 550);
          setTimeout(() => {
            $(".squares").removeClass("animate__animated animate__bounceOut");
            $(".squares").addClass("animate__animated animate__bounceIn");
            this.start();
            setTimeout(() => {
              $(".squares").removeClass("animate__animated animate__bounceIn");
            }, 550);
            $("#checkmark").css("display", "none");
          }, 2000);
        }, 2000);
      }
    },
  },
};
</script>

<style lang="less" scoped>
#goz_esnetme {
  width: 700px;
  max-width: 700px;
  height: 470px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background-image: url("/static/img/v728-mynt-36-Recovered.jpg") !important;
  flex-direction: column;
  background-size: 100%;
}

.squares {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  flex-wrap: wrap;
  background: white;
  transition: 0.5s;
}

.squares .square {
  background-color: #ddd;

  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: silver;
    cursor: pointer;
  }

  &.picked {
    background-color: blueviolet;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modules/HafizaKareleri.vue